import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { GlobalRoutingModelComponent } from '../components/global-routing-models.component';
import { selectGlobalRoutingModelsQueryItems } from '../../../../../redux/global-iship-cloud/global-routing-models/selector';
import { globalRoutingModels } from '../../../../../redux/global-iship-cloud/global-routing-models/action';

const GlobalRoutingModel = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectGlobalRoutingModelsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)

  const [
    routingModel,
    setRoutingModel
  ] = useState<any>({})

  const fetchRecordById = () => {
    dispatch(globalRoutingModels.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-routing-models/fetch-detail`, entity: 'globalRoutingModels', jsonData:
      {
        Context: {},
        Records: [
          {
            "GlobalServiceTypeId": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  useEffect(
    () => {
      if (parmas?.id > 0) {
        fetchRecordById()
      }
    }, [])

  useEffect(
    () => {
      if (isQuery) {
        setRoutingModel(queryItems?.result?.items)
      }
    }, [isQuery])

  const handleInnerBasicFormChange: any = (event: any, field: string) => {
    setRoutingModel({ ...routingModel, [field]: event });
  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

    if (parmas?.id > 0) {
      dispatch(globalRoutingModels.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-routing-models`, entity: 'globalRoutingModels', jsonData:
        {
          "Context": {},
          Records: [
            routingModel
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      dispatch(globalRoutingModels.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-routing-models`, entity: 'globalRoutingModels', jsonData:
        {
          "Context": {
          },
          Records: [
            routingModel
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = async () => {
    navigate(-1)
  }

  return (
    <>
      {queryItems?.isLoading ? <PageLoader /> :
        <GlobalRoutingModelComponent
          routingModel={routingModel}
          handleFormSubmit={handleFormSubmit}
          back={back}
          handleInnerBasicFormChange={handleInnerBasicFormChange}
        />}
    </>
  )

}

export default GlobalRoutingModel;